export function add(...terms: (string | number | undefined)[]): number {
    const rawSum = terms.reduce<number>((sum, cur) => sum + Math.round(Number(cur ?? 0) * 100), 0);
    return rawSum / 100;
}
